<template>
  <div class="modal fade" :id="''+id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ !isEdit ? $t('access.card.creation') : $t('access.card.modification') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                      fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                      fill="currentColor"/>
                                </svg>
                            </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <Input
                containerClass="col-12 mt-2 mb-5"
                :name="`${id}-name`"
                type="text"
                :label="$t('access.card.number')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :placeholder="$t('access.card.placeholder_number')"
                :isRequired="true" size="lg"
                v-model="formData.card_number"
            />
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>


</template>

<script setup>
import {ref, defineProps, computed, onMounted, watch} from 'vue'
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import Input from "@/components/Input.vue";
import Select2 from "@/components/Select2.vue";
import CreatePerimeter from "@/Modules/Access/components/Modals/Perimeters/CreateOrUpdatePerimeter.vue";

const store = useStore()

const props = defineProps({
  form: {
    type: Object,
    default: {
      id: '',
      card_number: '',
    }
  },
  id: {
    type: String,
    required: true
  },
  isEdit: {
    type: Boolean,
    required: false
  }
})

const emits = defineEmits(['load'])

const formData = ref(props.form)
const isLoading = ref(false)

watch(() => props.form, (value) => {
  formData.value = props.form
}, { deep: true })


function submitData(){
  isLoading.value = true
  let action = props.isEdit ? 'cards/updateCards' : 'cards/createCards'
  let message = props.isEdit ? 'notification.cards_updated' : 'notification.cards_created'

  store.dispatch(action, formData.value)
      .then((response) => {
        emits('load')
        isLoading.value = false
        closeModal()
        formData.value = {
          id: '',
          card_number: '',
        }
        window.toastr['success'](i18n.global.t(message))
      })
      .catch(err => {
        isLoading.value = false
      })
}

function closeModal(){
  $('#'+props.id).modal('toggle')
}
</script>